@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.head {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.refRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.ref {
  font-size: 14px;
  color: var(--text-tertiary);
}

.device {
  margin: 0;
  font-family: #{$font-family-heading};
  font-size: 20px;
  font-weight: var(--font-weight-regular);
  letter-spacing: -0.4px;
  color: var(--text-primary);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.fieldLabel {
  font-size: 13px;
  color: var(--text-muted);
}

.fieldValue {
  font-size: 14px;
  color: var(--text-primary);
  line-height: 1.5;
}

.attachLabel {
  font-size: 14px;
  color: var(--text-primary);
}

.thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  overflow: hidden;
  background: #f6f8f7;
  border-radius: 8px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

/* Status timeline (Figma 2715-811213): icon-disc rows, dashed connector, shipment on top. */
.timeline {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.timelineItem {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding-bottom: var(--space-6);

  &:last-child {
    padding-bottom: 0;
  }

  /* Dashed line through icon centers, hidden behind the opaque discs. */
  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 14px;
    top: 28px;
    bottom: 0;
    border-left: 1px dashed #cac7ba;
  }
}

.timelineIcon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  color: var(--text-secondary);
  background: var(--surface-card);
  border: 0.625px solid var(--border-subtle);
  border-radius: 50%;
}

.timelineText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 2px;
}

.timelineTitle {
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.timelineDate,
.timelineSub {
  font-size: 12px;
  color: var(--text-muted);
}

.timelineSub {
  color: var(--text-tertiary);
}

.deliveryDate {
  color: $color-success-700;
}

.trackingId {
  margin-left: auto;
  padding-top: 2px;
  font-size: 12px;
  color: var(--text-tertiary);
  white-space: nowrap;
}

.thread {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.comment {
  padding: var(--space-3) var(--space-4);
  background: $color-neutral-100;
  border-radius: 12px;
}

.commentMine {
  background: $color-stage-wip-bg;
}

.commentHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2);
  margin-bottom: 2px;
}

.commentAuthor {
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.commentTime {
  font-size: 11px;
  color: var(--text-muted);
}

.commentBody {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.composer {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: 1px solid $color-neutral-200;
}

.composerLabel {
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.send {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  align-self: flex-start;
  padding: 10px 18px;
  font-size: 14px;
  color: #fff;
  background: $color-green-primary-500;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
